<template>
  <div>
    <form @keyup.enter="search()" @submit.prevent>
      <b-row class="not-print my-4">
        <b-col cols="3">
          <client-search @personSelected="search($event)" />
        </b-col>
        <b-col cols="2">
          <date-input
            @input="search()"
            v-model="searchForm.date_start"
            alias="Data de Compra Inicial"
          />
        </b-col>
        <b-col cols="2">
          <date-input
            @input="search()"
            v-model="searchForm.date_end"
            alias="Data de Compra Final"
          />
        </b-col>
        <div class="ml-auto mr-4">
          <button type="button" class="btn btn-sm btn-primary" @click="print()">
            <i class="fas fa-print mr-1" /> Imprimir
          </button>
        </div>
      </b-row>
    </form>
    <div class="page" size="A4" v-for="page in pages" :key="'page' + page">
      <div class="row" style="margin: 3px">
        <div class="col">
          <b-card title="Extrato de Débitos">
            <div class="row">
              <div class="col-5">
                Cliente:
                <span v-if="bills">
                  #{{ bills.person.person_code }} -
                  {{ bills.person.name }}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col" v-if="searchForm.date_start">
                <span> Consulta realizada a partir de </span>
                {{ searchForm.date_start | dateBr }}
                <span v-if="searchForm.date_end">
                  até {{ searchForm.date_end | dateBr }}
                </span>
              </div>
            </div>
            <br />
            <div class="mr-2 row justify-content-between">
              <div class="col">
                <span class="font-weight-bold"
                  >Total de Contas em aberto:
                </span>
                {{ (bills.value_sum - bills.received_value_total) | moneyBr }}
              </div>
              <div class="col">
                <span class="font-weight-bold"
                  >Total de Contas recebidas:
                </span>
                {{ bills.received_value_total | moneyBr }}
              </div>
              <div class="col">
                <span class="font-weight-bold">Consulta Realizada :</span>
                {{ date | dateTimeBr }}
              </div>
            </div>
          </b-card>
        </div>
      </div>
      <div class="row" style="margin: 3px">
        <div class="col">
          <!-- <b-table
            x-small
            dense
            thead-class="d-none"
            tbody-class="text--small"
            outlined
            bordered
            show-empty
            :fields="[
              { key: 'name', label: 'Nome', class: 'font-weight-bold' },
            ]"
            :items="person"
            :current-page="page"
            :per-page="perPage"
            details-td-class="p-0"
          >
            <template #cell(name)="data">
              Cliente:
              {{ data.item.person.name }}

              - #{{ data.item.person.person_code }}
            </template> -->
          <!-- <template #cell(discount_total)="data">
              {{ data.item.discount_total | decimal }}
            </template>
            <template #cell(value_total)="data">
              {{ data.item.value_total | decimal }}
            </template>
            <template #cell(received_value_total)="data">
              {{ data.item.received_value_total | decimal }}
            </template>
            <template #cell(debit_total)="data">
              {{ data.item.debit_total | decimal }}
              <b-button size="sm" @click="data.toggleDetails">
                {{ data.detailsShowing ? "Hide" : "Show" }} Details
              </b-button>
            </template> -->

          <!-- <template #row-details="data"> -->
          <b-table
            small
            outlined
            bordered
            :current-page="page"
            :per-page="perPage"
            show-empty
            v-if="bills"
            :items="bills.person_bills"
            :fields="fields"
          >
            <template #cell(number)="data">
              {{ data.item.order.number }}
            </template>
            <template #cell(ordered_at)="data">
              {{ data.item.order.ordered_at | dateBr }}
            </template>
            <template #cell(order_total)="data">
              {{ data.item.order.net_total | decimal }}
            </template>
            <template #cell(interest_total)="data">
              {{ getInterest(data.item) | decimal }}
            </template>

            <template #cell(received_value_total)="data">
              {{ data.item.received_value_total | decimal }}
            </template>
            <template #cell(debit_total)="data">
              {{ data.item.debit_total | decimal }}
            </template>
          </b-table>
          <!-- </template> -->
          <!-- </b-table> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import ClientSearch from "@/components/ClientSearch";

export default {
  props: {},
  components: { ClientSearch },
  data() {
    return {
      showFilters: true,

      bills: {
        person: {},
        person_bills: null,
      },
      fields: [
        { key: "number", label: "Nº", class: "text-center" },
        { key: "ordered_at", label: "Data Compra", class: "text-center" },
        { key: "order_total", label: "Total da Compra", class: "text-center" },
        // { key: "addition_total", label: "Total de Acréscimos" },
        // { key: "discount_total", label: "Total de Descontos" },
        // { key: "received_value_total", label: "Total Recebido" },
        // { key: "debit_total", label: "Total Devedor" },
        // { key: "addition_total", label: "Acréscimo" },

        // { key: "discount_total", label: "Desconto	" },
        { key: "interest_total", label: "Juros", class: "text-center" },
        { key: "debit_total", label: "Saldo  Devedor", class: "text-center" },
      ],

      sum_payed: {},
      sum_value: {},
      sum_received: {},
      searchForm: {
        text: null,

        date_start: null,
        date_end: null,
        status: ["o"],
      },
    };
  },

  mounted() {
    this.$store.commit("pageHasLoaded");
  },

  computed: {
    pages() {
      return Math.ceil(this.itensCount / this.perPage);
    },
    date() {
      return moment().format();
    },
    company() {
      return this.$store.state.company;
    },

    interestFactor() {
      if (this.company.bill_interest_calculation_method == "s") {
        return parseFloat(this.company.bill_interest_rate / 100);
      } else {
        return parseFloat(
          Math.pow(this.company.bill_interest_rate / 100 + 1, 1 / 30)
        );
      }
    },

    perPage() {
      return 30;
    },

    itensCount() {
      if (this.bills.person_bills) {
        return this.bills.person_bills.length;
      }
      return 1;
    },
  },

  methods: {
    async search(person) {
      this.searchForm.person_id = person.id;

      await axios
        .get("/erp/billReceiveble/debit-statement", { params: this.searchForm })
        .then((response) => {
          this.bills = response.data.bills;
        })
        .catch((error) => {});
    },
    getInterest(bill) {
      let days = moment().diff(moment(bill.due_date, "YYYY-MM-DD"), "days");

      if (days < 0) {
        return 0;
      }

      if (this.company.bill_interest_calculation_method == "s") {
        return (
          (((bill.value - bill.received_value) * this.interestFactor) / 30) *
          days
        );
      } else {
        return (
          (bill.value - bill.received_value) *
          (Math.pow(this.interestFactor, days) - 1)
        );
      }
    },

    print() {
      window.print();
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  color: rgb(0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 11pt;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.not-print {
  display: flex;

  align-items: center;
  margin: 3px;
}

@page {
  size: A4;
  margin: 0.5cm;
  padding: 0.5cm;
}

@media print {
  .page {
    visibility: visible;
    margin: initial;
    border: rgba(0, 0, 0, 0.1);
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .not-print {
    display: none;
  }
}

hr.color {
  border: 1px solid black;
}
</style>
